import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

const CandidatesPageHeader = ({ children, className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            className={cn('border-border flex flex-row items-center border-b bg-white px-12 py-6', className)}
            {...props}
        >
            {children}
        </div>
    );
};

export default CandidatesPageHeader;
